//durations in milliseconds
export const TEN_SECOND_DURATION_IN_MILLISECONDS = 10000;
export const TWENTY_SECOND_DURATION_IN_MILLISECONDS = 20000;
export const THIRTY_SECOND_DURATION_IN_MILLISECONDS = 30000;
